import o from "react";
import e from "prop-types";
import k from "lodash.noop";
import q from "classnames";
import r from "./index236.mjs";
import { SELECT_STATES as f, SELECT_BASE_CLASS as s } from "./index160.mjs";
const j = ({ classes: d, state: p, disabled: l, required: n, multiple: i }) => q(
  r[s],
  r[`${s}--${p}`],
  l && r[`${s}--disabled`],
  n && r[`${s}--required`],
  i && r[`${s}--multiple`],
  d
), h = (d) => {
  const {
    classes: p,
    multiple: l,
    disabled: n,
    id: i,
    name: u,
    onChange: E,
    placeholder: m,
    placeholderDisabled: y,
    readonly: v,
    required: b,
    state: C,
    title: S,
    value: T,
    options: A,
    optionGroups: N = []
  } = d, _ = j({
    classes: p,
    state: C,
    disabled: n,
    required: b,
    multiple: l
  }), $ = (a = []) => l ? Array.from(a).map(({ value: t }) => t).join(",") : a[0].value, D = ({ target: { selectedOptions: a } }) => {
    E($(a));
  };
  return /* @__PURE__ */ o.createElement(
    "select",
    {
      className: _,
      disabled: n,
      id: i,
      name: u,
      onChange: D,
      multiple: l,
      placeholder: m,
      readOnly: v,
      required: b,
      title: S,
      value: T,
      "data-testid": i
    },
    m && !l ? /* @__PURE__ */ o.createElement("option", { value: "", disabled: y }, m) : null,
    A.map(({ value: a, label: t, disabled: c }) => /* @__PURE__ */ o.createElement("option", { key: a, value: a, disabled: c }, t, " ")),
    N.map(({ label: a, id: t, options: c }) => /* @__PURE__ */ o.createElement("optgroup", { key: t, label: a }, c.map(({ value: g, label: L, disabled: O = !1 }) => /* @__PURE__ */ o.createElement("option", { key: g, value: g, disabled: O }, L))))
  );
};
h.propTypes = {
  autocomplete: e.bool,
  classes: e.string,
  disabled: e.bool,
  id: e.string,
  children: e.node,
  name: e.string,
  onChange: e.func,
  multiple: e.bool,
  placeholder: e.string,
  placeholderDisabled: e.bool,
  readonly: e.bool,
  required: e.bool,
  state: e.oneOf(Object.values(f)),
  title: e.string,
  value: e.string,
  options: e.arrayOf(
    e.shape({
      label: e.string,
      value: e.string
    })
  )
};
h.defaultProps = {
  state: f.DEFAULT,
  value: "",
  options: [],
  onChange: k,
  placeholderDisabled: !0
};
export {
  f as SELECT_STATES,
  h as Select,
  h as default
};
